import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
  IconButton,
  Typography,
  Box
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import React, { useContext } from "react";
import { ProjectContext } from "../../contexts/ProjectContext";

export const DeleteElementDialog = (props) => {

  const { deleteElement, deleteElementById, deleteElementByIds} = useContext(ProjectContext);

  const handleConfirm = () => {
    let handled = false;
    
    if (props.id) {
      deleteElementById(props.id);
      handled = true;
      
    }
    if (props.ids) {
      deleteElementByIds(props.ids);
      handled = true;
    }

    if (!handled) {
      deleteElement();
    }
    
    props.handleClose();
    props.refreshLayout();
  }

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0px 12px 40px rgba(15, 23, 42, 0.18)'
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 2.5,
            pr: 2,
            pl: 3
          }}
        >
          <Box>
            <Typography variant="h6" component="div">
              Delete items
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Confirm this action to remove the selected elements from the project.
            </Typography>
          </Box>
          <IconButton
            aria-label="Close delete dialog"
            onClick={props.handleClose}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent
          dividers
          sx={{
            px: { xs: 2.5, sm: 3 },
            py: { xs: 2.5, sm: 3 },
            bgcolor: 'background.default'
          }}
        >
          <DialogContentText>
            Do you really want to delete selected item(s)?
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions
          sx={{
            px: { xs: 2.5, sm: 3 },
            py: { xs: 2.5, sm: 3 },
            bgcolor: 'background.paper',
            justifyContent: 'flex-end',
            gap: 1.5
          }}
        >
          <Button onClick={props.handleClose} variant="outlined" color="inherit" startIcon={<CancelIcon />}>Cancel</Button>
          <Button onClick={handleConfirm} variant="contained" color="error" startIcon={<DeleteIcon />}>Delete</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


